var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56976 16.0201C8.37976 16.0201 8.18977 15.9501 8.03977 15.8001C7.74977 15.5101 7.74977 15.0301 8.03977 14.7401L14.5898 8.19016C14.8798 7.90016 15.3598 7.90016 15.6498 8.19016C15.9398 8.48016 15.9398 8.96015 15.6498 9.25015L9.09976 15.8001C8.94976 15.9501 8.75976 16.0201 8.56976 16.0201Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98001 11.1099C7.89001 11.1099 7 10.2199 7 9.12991C7 8.03991 7.89001 7.1499 8.98001 7.1499C10.07 7.1499 10.96 8.03991 10.96 9.12991C10.96 10.2199 10.07 11.1099 8.98001 11.1099ZM8.98001 8.65991C8.72001 8.65991 8.5 8.86992 8.5 9.13992C8.5 9.40992 8.71001 9.6199 8.98001 9.6199C9.25001 9.6199 9.45999 9.40992 9.45999 9.13992C9.45999 8.86992 9.24001 8.65991 8.98001 8.65991Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.519 16.8399C14.429 16.8399 13.5391 15.9499 13.5391 14.8599C13.5391 13.7699 14.429 12.8799 15.519 12.8799C16.609 12.8799 17.4991 13.7699 17.4991 14.8599C17.4991 15.9499 16.609 16.8399 15.519 16.8399ZM15.519 14.3899C15.259 14.3899 15.0391 14.5999 15.0391 14.8699C15.0391 15.1399 15.249 15.3499 15.519 15.3499C15.789 15.3499 15.9991 15.1399 15.9991 14.8699C15.9991 14.5999 15.789 14.3899 15.519 14.3899Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountCard);
export default __webpack_public_path__ + "static/media/discount-card.37fdc77feca07f1b90a663c231456cb5.svg";
export { ForwardRef as ReactComponent };